/* Galbaci — display-only currency switch (INR ⇄ USD).
   The control itself is rendered in sections/galbaci-header.liquid, so it is part of
   the section markup and survives every re-render. This file only holds behaviour:
   remembering the choice, converting prices on screen, and marking the active half.
   Checkout always charges INR. USD is a rounded display conversion.
   Rate comes from data-rate on the <script> tag in theme.liquid (rupees per dollar). */
(function () {
  'use strict';

  var tag = document.querySelector('script[data-gb-currency]');
  var RATE = parseFloat((tag && tag.getAttribute('data-rate')) || '100') || 100;
  var KEY = 'gb-currency';
  var MONEY = /(?:₹|Rs\.?)\s?([0-9][0-9,]*(?:\.[0-9]{1,2})?)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, IFRAME: 1, SVG: 1 };

  var originals = new Map();
  var mode = 'INR';
  try { mode = localStorage.getItem(KEY) === 'USD' ? 'USD' : 'INR'; } catch (e) {}

  function usd(inr) {
    var n = Math.round(inr / RATE);
    if (n < 1) n = 1;
    return '$' + n.toLocaleString('en-US');
  }

  function convertText(t) {
    if (!t.nodeValue || t.nodeValue.indexOf('₹') < 0 && t.nodeValue.indexOf('Rs') < 0) return;
    var p = t.parentNode;
    if (!p || SKIP[p.nodeName] || p.closest && p.closest('[data-gb-noconv]')) return;
    var out = t.nodeValue.replace(MONEY, function (m, num) {
      var v = parseFloat(num.replace(/,/g, ''));
      if (!isFinite(v)) return m;
      return usd(v);
    });
    if (out !== t.nodeValue) {
      if (!originals.has(t)) originals.set(t, t.nodeValue);
      t.nodeValue = out;
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { convertText(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(convertText);
  }

  function restore() {
    originals.forEach(function (val, node) {
      if (node && node.parentNode) node.nodeValue = val;
    });
    originals.clear();
  }

  /* Marks the active half. Runs again after any re-render, so the freshly
     rendered buttons always show the remembered choice. */
  function mark() {
    document.documentElement.setAttribute('data-gb-currency', mode);
    document.querySelectorAll('.gb-curopt').forEach(function (b) {
      var on = b.getAttribute('data-cur') === mode;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function apply() {
    if (mode === 'USD') walk(document.body); else restore();
    mark();
  }

  function set(next) {
    if (!next || next === mode) return;
    mode = next;
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    if (mode === 'INR') restore();
    apply();
  }

  /* Delegated: works for buttons that exist now and any that replace them later. */
  function bind() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.gb-curopt');
      if (!btn) return;
      e.preventDefault();
      set(btn.getAttribute('data-cur'));
    });
  }

  function observe() {
    if (!window.MutationObserver) return;
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      if (mode !== 'INR') {
        if (!pending) {
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            muts.forEach(function (m) {
              if (m.type === 'characterData') convertText(m.target);
              else m.addedNodes && Array.prototype.forEach.call(m.addedNodes, walk);
            });
          });
        }
      }
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.classList && n.classList.contains('gb-curopt') || n.querySelector && n.querySelector('.gb-curopt'))) {
            mark();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    bind();
    apply();
    observe();
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:reorder', mark);
    window.addEventListener('load', mark);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
